var map = {
	"./favicon.ico": 27800,
	"./favicon_hyundai.ico": 57899,
	"./favicon_rokdcc.ico": 46748,
	"./favicon_samsungcard.ico": 43742,
	"./favicon_sgate.ico": 37806
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87755;